export default __webpack_public_path__ + "static/media/mauquenchy7.e878b64d.jpg";